import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the leadersSummary state domain
 */

const selectLeadersSummaryDomain = (state) =>
  state.get("leadersSummary", initialState)

/**
 * Other specific selectors
 */
export const makeSelectSummary = () =>
  createSelector(selectLeadersSummaryDomain, (state) => state.get("summary"))

export const makeSelectIsLoadingSummary = () =>
  createSelector(selectLeadersSummaryDomain, (state) =>
    state.get("isLoadingSummary")
  )
// percentage
export const makeSelectPercentage = () =>
  createSelector(selectLeadersSummaryDomain, (state) => state.get("percentage"))
/**
 * Default selector used by LeadersSummary
 */

const makeSelectLeadersSummary = () =>
  createSelector(selectLeadersSummaryDomain, (substate) => substate.toJS())

export default makeSelectLeadersSummary
export { selectLeadersSummaryDomain }
